export default __webpack_public_path__ + "static/media/imgAboutUs5.ac2c64da.png";